export function shouldShow(state, ...values) {
  return typeof state !== 'undefined' && values.includes(state)
}
